<template>
  <div id="myChart" style="width: 100%;height:300px;"></div>
</template>

<script>
const echarts = require("echarts");
export default {
  name: 'hello',
  props: ["getType", "chartData"],
  data() {
    return {
      xData: [],
      dData: [],
      sumData: null
    }
  },
  watch: {
    chartData() {

    }
  },
  mounted() {

    let data2 = this.chartData.data
    for (let item in data2) {
      this.xData.push({ text: this.getItem(item), max: 12, min: -10 })
      this.dData.push(data2[item])
    }
    for (var a = 0; a < this.dData.length; a++) {
      this.sumData += parseInt(this.dData[a])
    }
    this.drawLine(this.xData, this.dData, this.sumData);
  },
  methods: {
    getItem(e){
      return e.substr(0,e.indexOf('(') )
    },
    drawLine(xData, dData, sumData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('myChart'));
      // 绘制图表
      myChart.setOption({
        title: {
          text: sumData,
          x: 'center',
          y: 'center',
          textStyle: {
            color: '#fff',
            fontWeight: '600',
            fontSize: 50,
          }
        },
        // tooltip: {
        //   trigger: 'item'
        // },
        radar: {
          indicator: xData,
          splitNumber: 4,
          splitArea: {
            //设置渐变背景色
            areaStyle: {
              color: ['rgba(2, 99, 255,0.6)',
                'rgba(2, 99, 255,0.5)',
                'rgba(2, 99, 255,0.4)',
                'rgba(2, 99, 255,0.3)',
                'rgba(2, 99, 255,0.2)'],
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10
            }
          },
          shape: 'circle',
          axisName: {
            color: '#333',
            formatter: function(text){
                var strlength = text.length;
                if(strlength % 14 != 0){
                    text = text.replace(/\S{14}/g,function(match){
                        return match + '\n'
                    })
                }else{
                    text = text.replace(/\S{14}/g,function(match){
                        return match + '\n'
                    });
                    strlength = text.length;
                    text = text.substring(0,strlength - 1);
                }
                return text
            }
          },
          splitLine: {
            lineStyle: {
              color: '#c0c0c0'
            }
          }
        },
        series: (function () {
          var series = [];
          for (var i = 1; i <= 28; i++) {
            series.push({
              type: 'radar',
              symbol: 'none',
              lineStyle: {
                width: 1
              },
              emphasis: {
                areaStyle: {
                  color: 'rgba(2, 99, 255,1)'
                }
              },
              data: [
                {
                  value: dData,
                  name: i + 2000 + '',
                  areaStyle: { color: "rgba(2, 99, 255,.03)" }, //雷达覆盖区域背景颜色
                  lineStyle: {
                    color: "#3377fe",
                    width: 2,
                  },
                }
              ]
            });
          }
          return series;
        })()
      });
    }
  }
}
</script>

<style scoped lang="less">
.h {
  color: #409ef5;
}
#myChart{
  position: initial!important;
  margin-top: 20px;
}
</style>
